/** Four-digit calendar year (YYYY). */
export const YEAR_YYYY_PATTERN = /^\d{4}$/;

/**
 * Validates a year string: must be YYYY and not after the current calendar year.
 * Returns an error message, or empty string when valid.
 */
export function validateMaxCurrentYear(
  inputValue: string,
  message?: string
): string {
  const trimmed = String(inputValue ?? "").trim();
  if (!trimmed) return "";

  if (!YEAR_YYYY_PATTERN.test(trimmed)) {
    return message || "Enter a valid 4-digit year (YYYY)";
  }

  const year = parseInt(trimmed, 10);
  const currentYear = new Date().getFullYear();
  if (year > currentYear) {
    return message || `Year cannot be later than ${currentYear}`;
  }

  return "";
}
